module.exports = __webpack_public_path__ + "img/preview.0d579681.jpg";